/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    VerifyAppleReceiptDto,
    VerifyAppleReceiptDtoFromJSON,
    VerifyAppleReceiptDtoToJSON,
    VerifyAppleReceiptResponseDto,
    VerifyAppleReceiptResponseDtoFromJSON,
    VerifyAppleReceiptResponseDtoToJSON,
} from '../models';

export interface AppleControllerVerifyReceiptRequest {
    verifyAppleReceiptDto: VerifyAppleReceiptDto;
}

/**
 * 
 */
export class AppleApi extends runtime.BaseAPI {

    /**
     * Verify Apple receipt transaction
     */
    async appleControllerVerifyReceiptRaw(requestParameters: AppleControllerVerifyReceiptRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<VerifyAppleReceiptResponseDto>> {
        if (requestParameters.verifyAppleReceiptDto === null || requestParameters.verifyAppleReceiptDto === undefined) {
            throw new runtime.RequiredError('verifyAppleReceiptDto','Required parameter requestParameters.verifyAppleReceiptDto was null or undefined when calling appleControllerVerifyReceipt.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/apple/verify-receipt`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VerifyAppleReceiptDtoToJSON(requestParameters.verifyAppleReceiptDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VerifyAppleReceiptResponseDtoFromJSON(jsonValue));
    }

    /**
     * Verify Apple receipt transaction
     */
    async appleControllerVerifyReceipt(requestParameters: AppleControllerVerifyReceiptRequest, initOverrides?: RequestInit): Promise<VerifyAppleReceiptResponseDto> {
        const response = await this.appleControllerVerifyReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Apple App Store webhook
     */
    async appleControllerWebhookRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/apple/webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Apple App Store webhook
     */
    async appleControllerWebhook(initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.appleControllerWebhookRaw(initOverrides);
        return await response.value();
    }

}
